/*
 * FSR: List sold-out products last on collection pages.
 *
 * Shopify can't sort by availability, so the collection grid renders an
 * <fsr-stock-sort> marker when the current results mix in-stock and sold-out
 * products. This element swaps the grid content for the in-stock results
 * (hidden availability filter). From there, "load more" continues with the
 * sold-out results once the in-stock pages run out (see flotilla-collection-grid).
 */
class FsrStockSort extends HTMLElement {
  connectedCallback() {
    this.grid = this.closest('[data-armada-selector="collection-grid-main"]');
    if (!this.grid || !this.dataset.url) return;
    this.swap();
  }

  async swap() {
    const url = new URL(this.dataset.url, window.location.origin);
    url.searchParams.delete('section_id');
    url.searchParams.set('section_id', this.dataset.sectionId);

    try {
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const freshGrid = html.querySelector('[data-armada-selector="collection-grid-main"]');

      // The filters may have changed while we were fetching; a newer grid owns the DOM then.
      if (!this.isConnected || !freshGrid) throw new Error('Grid changed or missing');

      this.loadMissingScripts(freshGrid);
      this.grid.innerHTML = freshGrid.innerHTML;
    } catch (error) {
      this.reveal();
    }
  }

  // Scripts in injected markup don't run, so load any the current page doesn't have yet
  // (e.g. the load-more component when the unfiltered page had only one page).
  loadMissingScripts(container) {
    container.querySelectorAll('script[src]').forEach((script) => {
      const src = script.getAttribute('src');
      const path = src.split('?')[0];
      const alreadyLoaded = [...document.scripts].some((s) => s.src && s.src.includes(path));
      if (alreadyLoaded) return;

      const newScript = document.createElement('script');
      newScript.src = src;
      newScript.type = script.type || 'text/javascript';
      document.head.appendChild(newScript);
    });
  }

  reveal() {
    const cardGrid = this.grid && this.grid.querySelector('.fsr-stock-sort-pending');
    if (cardGrid) cardGrid.classList.remove('fsr-stock-sort-pending');
  }
}

if (!customElements.get('fsr-stock-sort')) customElements.define('fsr-stock-sort', FsrStockSort);
